<template lang="pug">
BriqPanel
  .panel-header
    slot(name="header")
    slot(name="actions")
  slot(name="body")
</template>

<script>
export default {
  name: 'EditDealTabSection',
  props: {
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped lang="stylus">
@import '~@v/variables.styl'

.panel-header
  display flex
  justify-content space-between
  margin-bottom space-M
  align-items flex-start
</style>
